
export const propertyLabels: { [key: string]: { label: string; ordem?: number }; } = {

    razaoSocial: { label: "Razão Social", ordem: 1 },
    cnpj: { label: "CNPJ", ordem: 2 },
    email: { label: "Email", ordem: 3 },
    telefone: { label: "Telefone", ordem: 4 },
    tipoLojaDescricao: { label: "Tipo de Loja", ordem: 5 }
};

export const modalTitulo = "Loja";
export const modalTexto = "Deseja remover a loja?"
export const UrlTipoLoja = "TipoLoja";
export const UrlPaginado = "Loja/BuscarPaginado";
export const UrlLoja = "Loja";
export const UrlBuscarTodos = "Loja"